<template>
  <div>
    <p>Fjärrsupport gör det möjligt får supporten att ansluta till din Bridge för att administrera den. Du behöver <strong>endast</strong> aktivera detta om supporten ber dig att göra det eller ifall du skickar in ett ärende.</p>
    
    <p v-if="$root.data.info.remoteSupportPort">Ge följande kod till supporten: <strong>{{ $root.data.info.remoteSupportPort }}</strong></p>
    
    <button @click="toggle" :disabled="loading"><span v-if="loading">Var god vänta...</span><span v-else>{{ $root.data.info.remoteSupportPort ? 'Stäng av fjärrsupport' : 'Aktivera fjärrsupport' }}</span></button>
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  
  export default {
    name: 'installningar_template',
    data () {
      return {
        loading: false
      }
    },
    created () {

    },
    methods: {
      toggle () {
        const port = Math.floor(Math.random() * (9999 - 1000 + 1) + 1000)       
        this.loading = true
        
        // Fjärrsupport är på, stäng av det
        if (this.$root.data.info.remoteSupportPort) {
          HTTP.post('actions/remoteSupportAbort')
          .then(res => res.data)
          .then(json => {
            this.$root.data.info.remoteSupportPort = 0
            this.loading = false
          })
        } else {
          HTTP.post('actions/remoteSupport?port=' + port)
          .then(res => res.data)
          .then(json => {
            this.$root.data.info.remoteSupportPort = port
            this.loading = false
          })
        }
      }
    },
    computed: {},
    destroyed () {}
  }
</script>


// WEBPACK FOOTER //
// src/components/installningar_remotesupport.vue